import React from 'react'

function SupplierReport() {
  return (
    <div>SupplierReport</div>
  )
}

export default SupplierReport